import { BaseGraphicsProvider } from "elements/base/graphics";
import { ResizeType } from "elements/base/types";
import type { GanttElement } from "elements/gantt/schema";

export default class GanttGraphicsProvider extends BaseGraphicsProvider<GanttElement> {
  getResizeType(): ResizeType {
    return ResizeType.All;
  }
}
